export const CARD_1 = 'card_1';
export const CARD_2 = 'card_2';
export const CARD_3 = 'card_3';
export const CARD_4 = 'card_4';
export const CARD_5 = 'card_5';
export const CARD_6 = 'card_6';
export const CARD_7 = 'card_7';
export const CARD_8 = 'card_8';
export const CARD_9 = 'card_9';
export const CARD_10 = 'card_10';
export const CARD_11 = 'card_11';
export const CARD_11_1 = 'card_11_1';
export const CARD_12 = 'card_12';
export const CARD_13 = 'card_13';
export const CARD_14 = 'card_14';
export const CARD_15 = 'card_15';
export const CARD_16 = 'card_16';
export const CARD_17 = 'card_17';
export const CARD_18 = 'card_18';
export const CARD_19 = 'card_19';
export const CARD_20 = 'card_20';
export const CARD_21 = 'card_21';
export const CARD_22 = 'card_22';
export const CARD_22_1 = 'card_22_1';
export const CARD_23 = 'card_23';
export const CARD_24 = 'card_24';
export const CARD_25 = 'card_25';
export const CARD_26 = 'card_26';
export const CARD_27 = 'card_27';
export const CARD_27_1 = 'card_27_1';
export const CARD_28 = 'card_28';
export const CARD_29 = 'card_29';
export const CARD_30 = 'card_30';
export const CARD_31 = 'card_31';
export const CARD_32 = 'card_32';
export const CARD_33 = 'card_33';
export const CARD_34 = 'card_34';
export const CARD_35 = 'card_35';
export const CARD_36 = 'card_36';
export const CARD_37 = 'card_37';
export const CARD_38 = 'card_38';
